// extracted by mini-css-extract-plugin
export default {"accordionHeading":"Accordion_accordionHeading__LiWdj","accordionDescription":"Accordion_accordionDescription__tSev5"};